var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGastosYCuotas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 22,
    fill: "none",
    viewBox: "0 0 25 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    d: "M20.59 10.653c-.398 0-.716.316-.716.71v9.216H4.627v-9.216c0-.394-.318-.71-.716-.71-.397 0-.715.316-.715.71v9.926c0 .395.318.711.715.711H20.59c.397 0 .716-.316.716-.71v-9.927c0-.394-.319-.71-.716-.71zM24.22 8.857l-5.1-3.853V1.898c0-.39-.318-.704-.715-.704-.397 0-.716.314-.716.704v2.027L12.687.145c-.255-.193-.618-.193-.873 0L.28 8.856c-.314.236-.372.68-.132.988.24.308.69.366 1.004.13L12.25 1.589 23.35 9.97c.132.096.284.144.436.144.215 0 .426-.096.568-.274.24-.303.181-.747-.132-.983z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    stroke: "#6C7281",
    strokeWidth: 0.2,
    d: "M14.08 13.514c-.001 1.05-.71 1.949-1.684 2.133v.514c0 .309-.236.56-.527.56-.29 0-.526-.251-.526-.56v-.52c-.678-.181-1.236-.693-1.5-1.38-.08-.185-.058-.402.056-.565.115-.164.304-.248.494-.22.19.028.35.163.42.353.18.457.6.753 1.065.752.556 0 1.153-.338 1.153-1.076 0-.194 0-.782-1.263-1.09h-.019c-1.8-.448-2.07-1.552-2.07-2.176.002-1.05.711-1.948 1.685-2.132v-.508c0-.309.236-.559.526-.559.291 0 .527.25.527.559v.52c.679.176 1.24.684 1.51 1.37.072.183.047.395-.067.554-.113.159-.298.242-.485.217-.186-.025-.346-.154-.42-.338-.179-.456-.6-.753-1.065-.751-.555 0-1.153.337-1.153 1.075 0 .194 0 .782 1.263 1.09h.019c1.791.448 2.06 1.557 2.06 2.178z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGastosYCuotas);
export default __webpack_public_path__ + "static/media/gastos-y-cuotas.ee93bb530e13d81a5bd1459e2114ecbc.svg";
export { ForwardRef as ReactComponent };